import MapMenu from '../lib/map_menu';
import UiInteraction from '../lib/ui_interaction';

export default class BcycleLayer {
	constructor() {
		this.checkboxEl = document.getElementById('bcycle-layer');
		this.visible = false;
	}

	add() {
		const url = W.api_root + 'bcycle.geojson';
		if (!W.map.getSource('bycycle-source')) {
			W.map.addSource('bycycle-source', {
				type: 'geojson',
				data: url,
			});
		}

		W.map.addLayer({
			id: 'bycycle-layer',
			type: 'symbol',
			source: 'bycycle-source',
			layout: {
				'icon-image': 'marker-bcycle',
				'icon-offset': [0, 0],
				'icon-anchor': 'bottom',
				'icon-size': 1.5,
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
			},
		});

		this.visible = true;
		W.LayerUtils.setView('bycycle-layer');
		MapMenu.hide();
	}

	remove() {
		W.map.removeLayer('bycycle-layer');
		UiInteraction.clearAllPopups();
		this.visible = false;
	}

	async getData() {
		const url = W.api_root + 'parking';

		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}

			const json = await response.json();
			this.lots = json.features;
		} catch (error) {
			console.error(error.message);
		}
	}
}
